var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34447 6.00254L6.7872 1.51317C6.90953 1.38985 6.97683 1.22498 6.97683 1.04917C6.97683 0.873268 6.90953 0.708488 6.7872 0.584976L6.39791 0.191805C6.27577 0.0680976 6.1125 0 5.93851 0C5.76453 0 5.60145 0.0680976 5.47922 0.191805L0.189437 5.53678C0.0667198 5.66068 -0.000480172 5.82624 2.58675e-06 6.00224C-0.000480172 6.17902 0.0666233 6.34439 0.189437 6.46839L5.47429 11.8082C5.59653 11.9319 5.7596 12 5.93369 12C6.10767 12 6.27075 11.9319 6.39308 11.8082L6.78228 11.415C7.03553 11.1591 7.03553 10.7425 6.78228 10.4867L2.34447 6.00254Z",
    fill: "#1A110F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.c88f3fab4c075e34a84d09d855dd15c7.svg";
export { ForwardRef as ReactComponent };